import React, { useEffect, useState } from "react"
import { images } from "../../constants"
import { motion } from "framer-motion"
import "./Hero.css"
import { gtagSendEvent } from "../../utils/gtaghelper"
import { usePopup } from "../../context/PopupContext"

const HeroM = () => {
  const { openPopup } = usePopup()
  const DEFAULT_PRICE = "499"

  const OFFER_CODES = {
    EARLY: 349,
    SPECIAL: 399,
    DEFAULT: "499",
    PREMIUM: "999",
    SINGLE: 249,
    NEW: "499",
  }

  const [price, setPrice] = useState(DEFAULT_PRICE)
  const [offerApplied, setOfferApplied] = useState("")

  // 🌎 Neutral, trust-safe features
  const DEFAULT_FEATURES = [
    "Up to 5 professionally designed pages",
    "SEO-ready for Google ranking",
    "Mobile & speed optimized",
    "Contact form + analytics setup",
    "Built for modern small businesses",
  ]

  const EARLY_FEATURES = [
    "Up to 3 professionally designed pages",
    "SEO-ready website",
    "Mobile responsive design",
    "Contact form integration",
    "Fast 7-day delivery",
  ]

  const PREMIUM_FEATURES = [
    "Up to 10 premium pages",
    "Advanced on-page SEO",
    "Speed optimization",
    "Conversion-focused layout",
    "Priority delivery & support",
  ]

  const SINGLE_FEATURES = [
    "Single-page professional website",
    "Basic SEO setup",
    "Mobile optimized",
    "Contact form setup",
    "Fast launch",
  ]

  const NEW_FEATURES = [
    "Up to 5 professionally designed pages",
    "SEO-ready for Google ranking",
    "Mobile & speed optimized",
    "Contact form + analytics setup",
    "Built for modern small businesses",
  ]

  const [features, setFeatures] = useState(DEFAULT_FEATURES)

  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    const offerCode = params.get("offer")?.toUpperCase()

    if (offerCode && OFFER_CODES.hasOwnProperty(offerCode)) {
      setPrice(OFFER_CODES[offerCode])
      setOfferApplied(offerCode)

      switch (offerCode) {
        case "PREMIUM":
          setFeatures(PREMIUM_FEATURES)
          break
        case "SINGLE":
          setFeatures(SINGLE_FEATURES)
          break
        case "NEW":
          setFeatures(NEW_FEATURES)
          break
        case "EARLY":
          setFeatures(EARLY_FEATURES)
          break
        default:
          setFeatures(DEFAULT_FEATURES)
      }
    }
  }, [])

  return (
    <motion.section
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ delay: 0.2 }}
      className="hero"
    >
      <div className="row align-items-center pb-4 px-3">
        {/* LEFT */}
        <div className="col-md-6 col-12">
          {/* HERO TITLE */}
          <h1 className="title_hero">
            Professional Business Websites in&nbsp;
            <span
              className="px-2"
              style={{ color: "black", backgroundColor: "#b9ff66" }}
            >
              7 Days
            </span>
          </h1>

          {/* SUB-TITLE */}
          <p
            className="mt-1"
            style={{
              fontSize: "0.95rem",
              opacity: 0.85,
            }}
          >
            Built for <strong>Small Businesses & Startups</strong>
          </p>

          {/* RATING */}
          <p className="mt-2">
            ⭐⭐⭐⭐⭐ Trusted by <strong>200+ Businesses</strong>
          </p>

          {/* PRICING */}
          <div className="mt-3">
            <p style={{ fontSize: "1.1rem", marginBottom: "6px" }}>
              Website packages starting at
            </p>

            {offerApplied ? (
              <>
                <span
                  style={{
                    textDecoration: "line-through",
                    opacity: 0.4,
                    fontSize: "1.1rem",
                  }}
                >
                  ${DEFAULT_PRICE} CAD
                </span>
                <span
                  style={{
                    fontSize: "2rem",
                    fontWeight: "700",
                    marginLeft: "10px",
                  }}
                >
                  ${price} CAD*
                </span>
                <div
                  style={{
                    display: "inline-block",
                    marginTop: "6px",
                    padding: "4px 10px",
                    background: "#b9ff66",
                    fontSize: "0.9rem",
                    fontWeight: "600",
                  }}
                >
                  {offerApplied} offer applied 🎉
                </div>
              </>
            ) : (
              <span style={{ fontSize: "2rem", fontWeight: "700" }}>
                ${price} CAD*
              </span>
            )}
          </div>

          <p style={{ fontSize: "0.9rem", opacity: 0.8 }}>
            *Custom-designed • No hidden fees
          </p>

          {/* FEATURES */}
          <ul className="features-list mt-3" style={{ paddingLeft: "0" }}>
            {features.map((feature, index) => (
              <li key={index} style={{ marginBottom: "8px" }}>
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="3"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  style={{ color: "#16a34a", marginRight: "8px" }}
                >
                  <polyline points="20 6 9 17 4 12" />
                </svg>
                {feature}
              </li>
            ))}
          </ul>

          {/* PRIMARY CTA */}
          <button
            className="delivery-badge mt-3"
            onClick={() => openPopup({ source: "Hero — Book Free Consultation" })}
          >
            Book Free Consultation
          </button>

          <p className="mt-2 text-muted" style={{ fontSize: "0.85rem" }}>
            Limited consultation slots available
          </p>
        </div>

        {/* RIGHT */}
        <div className="col-md-6 col-12 mt-md-0 mt-4 text-center">
          <img
            className="img-fluid"
            src={images.hero}
            alt="Professional business website preview"
          />
        </div>
      </div>
    </motion.section>
  )
}

export default HeroM